import { takeLatest, call, select, put, delay } from "redux-saga/effects"

import {
	GET_ALL_DOCUMENTS_REQUEST,
	GET_DOCUMENTS_REQUEST,
	GET_DOCS_SOURCES,
	GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST,
	GET_DOCUMENT_PAGE_REQUEST,
} from "../types"
import { documentsService } from "../services/documents.services"
import { reviewService } from "../services/review.services"
import {
	getAllDocumentsInBackgroundRequestSuccess,
	getAllDocumentsRequestFailed,
	getAllDocumentsRequestFailedClear,
	getAllDocumentsRequestSuccess,
	getDocumentsRequestFailed,
	getDocumentsRequestFailedClear,
	getDocumentsRequestSuccess,
} from "../actions/viewdocumentsActions"
import { hideAlert, showAlertAction } from "../actions/alertActions"
import { logoutUser } from "../actions/userActions"
import { clearMultibase } from "../actions/multiAiBase"
import { CONTEXT_TYPE, CLIENT_SIDE_MESSAGES as Messages, buildQueryString, clearLocalStorage, payloadParsing } from "../utils"
import { DEFAULT_SOURCES } from "../utils"
import axios from "../services/axios"
import axiosClient from "axios"
import { setFilterJobId } from "../actions/filterActions"
import { history } from "../helpers/history"
import { getRetainFiltersSuccess } from "../actions/infoActions"
import { adminReviewMapSaga } from "./review_sagas"

const getStatusByJobId = async (id) => {
	return await axios.get(`/job/${id}`)
}

const getPsearchStatusByJobId = async (id) => {
	return await axios.get(`/p_search/${id}`)
}

const getSource = async () => {
	return await axios.get("/documents/sources")
}

function* getAllDocumentsSaga(action) {
	try {
		//let response = null
		// if (action?.payload?.jobIdToRetainData && !action?.payload?.triggerPSearch) {
		// 	response = { data: { success: true, job_id: action?.payload?.jobIdToRetainData } }
		// } else {
		// 	response = yield call(documentsService.getDocuments, action.payload?.params)
		// }

		let response = null
		const payload = payloadParsing(action.payload?.params) //new payload conversion
		if (action.payload?.params?.additional_params?.review_id) {
			//review search API
			const { is_case_admin, review_id, ...restPayload } = payload
			response = yield call(reviewService.getReviewSearch, { review_id, is_case_admin }, restPayload)
		} else {
			//search API
			response = yield call(documentsService.getDocuments, payload)
		}

		if (response?.data?.success) {
			const queryString = buildQueryString(action.payload?.params) //for querystring use old payload
			const url = `${window.location.pathname}?${queryString}`
			history.push(url)
			//yield put(getRetainFiltersSuccess(action.payload.params))

			const ids = response.data.data.map((item) => item.file_id)

			let contextId, context
			if (action.payload?.additional_params?.review_id) {
				contextId = action.payload?.additional_params?.review_id
				context = CONTEXT_TYPE.REVIEW
			} else if (action.payload?.additional_params?.search_id) {
				contextId = action.payload?.additional_params?.search_id
				context = CONTEXT_TYPE?.SEARCH
			}

			const metadata = yield call(documentsService.getFilesMetadata, ids, contextId, context)
			if (metadata?.data?.data?.length) {
				yield put(
					getAllDocumentsRequestSuccess({
						data: { ...metadata.data, count: response?.data?.count },
						count: response?.data?.count,
					})
				)

				//if review_id & user is caseAdmin
				if (action.payload?.additional_params?.review_id && action.payload?.additional_params?.is_case_admin) {
					//demoData => metadata.data.data
					yield call(adminReviewMapSaga, metadata.data.data)
				}
			} else {
				yield put(
					getAllDocumentsRequestSuccess({
						data: [],
						count: 0,
					})
				)
			}

			//----------------------------

			/*if (response) yield put(setFilterJobId(response?.data?.job_id))
			let jobId = yield call(getStatusByJobId, response?.data?.job_id)

			while ((jobId?.data && jobId.data.job.job_status.success === false) || jobId.data.job.job_status.is_finished === false) {
				yield delay(1000)
				jobId = yield call(getStatusByJobId, response.data.job_id)
			}

			if (jobId?.data && jobId.data.job.job_status.success === true) {
				const concept = yield call(getPsearchStatusByJobId, response.data.job_id)

				if (Object.keys(concept?.data?.data)?.length <= 0) {
					yield put(getAllDocumentsRequestSuccess({ data: { count: 0 }, count: 0 })) //To do: update when count is returned in the response
				} else {
					const count = concept.data.data.count || 0
					const docIdArray = []
					for (var i = 0; i < concept.data.data.data.length; i++) {
						docIdArray.push(`${concept.data.data.data[i].id}`)
					}

					let contextId, context
					if (action.payload?.additional_params?.review_id) {
						contextId = action.payload?.additional_params?.review_id
						context = CONTEXT_TYPE.REVIEW
					} else if (action.payload?.additional_params?.search_id) {
						contextId = action.payload?.additional_params?.search_id
						context = CONTEXT_TYPE?.SEARCH
					}

					const allDocuments = yield call(documentsService.getFilesMetadata, docIdArray, contextId, context)

					yield put(getAllDocumentsRequestSuccess({ data: { ...allDocuments.data, count: count }, count: count })) //To do: update when count is returned in the response
				}
			}*/
		} else {
			yield put(getAllDocumentsRequestFailed(response?.message))
			yield delay(3000) //After 3sec message disappear
			yield put(getAllDocumentsRequestFailedClear())
			yield put(
				getAllDocumentsRequestSuccess({
					data: [],
					count: 0,
				})
			)
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error?.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getAllDocumentsRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(getAllDocumentsRequestFailedClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getAllDocumentsInBackgroundSaga(action) {
	const {
		searchText = [],
		filter = [],
		concepts = [],
		cancelToken,
		returnCount: returnCount = 20,
		skip_count = 0,
		isFirstLoad = false,
	} = action.payload
	try {
		let sourceApi = yield select((state) => state.sources.docs_sources)
		const response = yield call(
			documentsService.searchAllDocuments,
			searchText,
			"",
			filter,
			concepts,
			false,
			returnCount,
			cancelToken,
			sourceApi,
			skip_count
		)
		if (response?.data?.success) {
			let jobId = yield call(getStatusByJobId, response.data.job_id)

			while ((jobId?.data && jobId.data.job.job_status.success === false) || jobId.data.job.job_status.is_finished === false) {
				yield delay(1000)
				jobId = yield call(getStatusByJobId, response.data.job_id)
			}

			if (jobId?.data && jobId.data.job.job_status.success === true) {
				const concept = yield call(getPsearchStatusByJobId, response.data.job_id)
				const count = concept.data.data.count || 0

				const docIdArray = []
				for (var i = 0; i < concept.data.data.data.length; i++) {
					docIdArray.push(`${concept.data.data.data[i].id}`)
				}

				const allDocuments = yield call(documentsService.getDocumentsMetadata, docIdArray)
				if (allDocuments?.data?.data.length) {
					yield put(getAllDocumentsInBackgroundRequestSuccess({ data: { ...allDocuments.data, count: count }, count: count })) //To do: update when count is returned in the response
				} else {
					console.log("No data")
				}
			}
		} else {
			console.log("Background get all document failed")
		}
	} catch (error) {
		console.log(error)
	}
}

function* getDocumentsSaga(action) {
	const id = action.payload
	try {
		const response = yield call(documentsService.getDocumentsData, [id])
		if (response?.data?.success) {
			yield put(getDocumentsRequestSuccess(response?.data?.data[0]))
		} else {
			yield put(getDocumentsRequestFailed(response.message))
			yield delay(3000) //After 3sec message disappear
			yield put(getDocumentsRequestFailedClear())
		}
	} catch (error) {
		console.log(error)
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getDocumentsRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(getDocumentsRequestFailedClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export default function* documentsSagas() {
	yield takeLatest(GET_ALL_DOCUMENTS_REQUEST, getAllDocumentsSaga)
	yield takeLatest(GET_ALL_DOCUMENTS_IN_BACKGROUND_REQUEST, getAllDocumentsInBackgroundSaga)
	yield takeLatest(GET_DOCUMENTS_REQUEST, getDocumentsSaga)
}
